import { render } from "./Orders.vue?vue&type=template&id=49c536a6&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import "./Orders.vue?vue&type=style&index=0&id=49c536a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c536a6"]])

export default __exports__